{{ label }}
<div
  #editor
  contenteditable="true"
  class="editor"
  (input)="formatJson($event)"
></div>
